"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaV2Api = exports.MediaV2ApiFactory = exports.MediaV2ApiFp = exports.MediaV2ApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * MediaV2Api - axios parameter creator
 */
const MediaV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaCopyDataToNewRecipientV2: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, mediaRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('mediaCopyDataToNewRecipientV2', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('mediaCopyDataToNewRecipientV2', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('mediaCopyDataToNewRecipientV2', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/copy`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/copy`,
                sdkMethod: 'mediaCopyDataToNewRecipientV2',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:         * reset progress duration for all guides in the pack class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRecipientPackClassPrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, _class, mediaUpdatePackClassPrograms, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('patchRecipientPackClassPrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('patchRecipientPackClassPrograms', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('patchRecipientPackClassPrograms', '_class', _class);
            const localVarPath = `/v2/media/recipients/{recipient_id}/packs/{class}/programs`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{class}', encodeURIComponent(String(_class)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/packs/{class}/programs`,
                sdkMethod: 'patchRecipientPackClassPrograms',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdatePackClassPrograms, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add a guide or program to a playlist. Returns 409 if the content is already present in the playlist. Returns 404 if the playlist does not exist or does not belong to the recipient. Returns 422 if the playlist has reached the 256-item limit.
         * @summary Add an item to a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {MediaCreatePlaylistItemRequest} mediaCreatePlaylistItemRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AddPlaylistItem: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, playlistId, mediaCreatePlaylistItemRequest, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2AddPlaylistItem', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2AddPlaylistItem', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2AddPlaylistItem', 'recipientId', recipientId);
            // verify required parameter 'playlistId' is not null or undefined
            (0, common_1.assertParamExists)('v2AddPlaylistItem', 'playlistId', playlistId);
            // verify required parameter 'mediaCreatePlaylistItemRequest' is not null or undefined
            (0, common_1.assertParamExists)('v2AddPlaylistItem', 'mediaCreatePlaylistItemRequest', mediaCreatePlaylistItemRequest);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/items`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{playlist_id}', encodeURIComponent(String(playlistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/items`,
                sdkMethod: 'v2AddPlaylistItem',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaCreatePlaylistItemRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add a guide to one or more playlists. Playlists where the content already exists are skipped. Returns 404 if any playlist does not exist or does not belong to the recipient. Returns 422 if any playlist has reached the 256-item limit.
         * @summary Add an item to multiple playlists
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaBulkCreatePlaylistItemRequest} mediaBulkCreatePlaylistItemRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BulkAddPlaylistItem: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, mediaBulkCreatePlaylistItemRequest, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2BulkAddPlaylistItem', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2BulkAddPlaylistItem', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2BulkAddPlaylistItem', 'recipientId', recipientId);
            // verify required parameter 'mediaBulkCreatePlaylistItemRequest' is not null or undefined
            (0, common_1.assertParamExists)('v2BulkAddPlaylistItem', 'mediaBulkCreatePlaylistItemRequest', mediaBulkCreatePlaylistItemRequest);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/items`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/items`,
                sdkMethod: 'v2BulkAddPlaylistItem',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaBulkCreatePlaylistItemRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new playlist for the recipient with an initial item. Returns 422 if the recipient already has 64 playlists.
         * @summary Create a playlist for a recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaCreatePlaylistRequest} mediaCreatePlaylistRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CreatePlaylist: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, mediaCreatePlaylistRequest, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2CreatePlaylist', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2CreatePlaylist', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2CreatePlaylist', 'recipientId', recipientId);
            // verify required parameter 'mediaCreatePlaylistRequest' is not null or undefined
            (0, common_1.assertParamExists)('v2CreatePlaylist', 'mediaCreatePlaylistRequest', mediaCreatePlaylistRequest);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists`,
                sdkMethod: 'v2CreatePlaylist',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaCreatePlaylistRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft delete recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeleteGuides: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2DeleteGuides', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2DeleteGuides', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeleteGuides', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}`,
                sdkMethod: 'v2DeleteGuides',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft-delete a playlist and all its items. Only the owning recipient may delete their playlist. Returns 404 if the playlist does not exist or is already deleted.
         * @summary Delete a recipient\'s playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeletePlaylist: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, playlistId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylist', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylist', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylist', 'recipientId', recipientId);
            // verify required parameter 'playlistId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylist', 'playlistId', playlistId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{playlist_id}', encodeURIComponent(String(playlistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`,
                sdkMethod: 'v2DeletePlaylist',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft-delete a single item from a playlist. Returns 404 if the item does not exist or does not belong to the recipient\'s playlist.
         * @summary Remove an item from a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {number} itemId Playlist Item ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeletePlaylistItem: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, playlistId, itemId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylistItem', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylistItem', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylistItem', 'recipientId', recipientId);
            // verify required parameter 'playlistId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylistItem', 'playlistId', playlistId);
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeletePlaylistItem', 'itemId', itemId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/items/{item_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{playlist_id}', encodeURIComponent(String(playlistId)))
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/items/{item_id}`,
                sdkMethod: 'v2DeletePlaylistItem',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Permanently delete all guides and playlists (including items) for a recipient.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ExpungePrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2ExpungePrograms', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2ExpungePrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2ExpungePrograms', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/expunge`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/expunge`,
                sdkMethod: 'v2ExpungePrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get recently played clinical guides, favorite clinical guides
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgramGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgramGuide', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgramGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgramGuide', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}`,
                sdkMethod: 'v2GetClinicalProgramGuide',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch user\'s progress of clinical media
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [clinicalProgramsOnly] If true, only return progress only for clinical programs
         * @param {Array<string>} [packClasses] If provided, only return progress for the specified clinical pack classes. If not provided, return progress for all known clinical pack classes.  **Note: given packClasses should be clinical pack classes.**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgress: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, clinicalProgramsOnly, packClasses, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/progress`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clinicalProgramsOnly !== undefined) {
                localVarQueryParameter['clinicalProgramsOnly'] =
                    clinicalProgramsOnly;
            }
            if (packClasses) {
                localVarQueryParameter['packClasses'] = packClasses;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/progress`,
                sdkMethod: 'v2GetClinicalProgress',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch one or more feeds (collections of packs) from the DTC Content Service. The feeds are cached using the standard Redis caching pattern. Response order will match the order of requested feed IDs.
         * @summary Get feeds by ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} feedId One or more feed IDs, sent in the form feed_id&#x3D;calm-health-home&amp;feed_id&#x3D;calm-health-anxiety&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetFeeds: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, feedId, acceptLanguage, strict, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetFeeds', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetFeeds', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetFeeds', 'recipientId', recipientId);
            // verify required parameter 'feedId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetFeeds', 'feedId', feedId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/feeds`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (feedId) {
                localVarQueryParameter['feed_id'] = feedId;
            }
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/feeds`,
                sdkMethod: 'v2GetFeeds',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data. Note: This endpoint returns programs with guides. Response order will match the order of requested guide IDs (by first occurrence of each guide\'s program).
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;... Response order will match the order of requested IDs (by first occurrence of each guide\&#39;s program).
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {boolean} [includeAllGuides] Default value is false. If true, returns all guides in the response, even if the recipient has no progress with the guide.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetGuides: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, guideId, acceptLanguage, strict, includeAllGuides, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'recipientId', recipientId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'guideId', guideId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/guides`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (guideId) {
                localVarQueryParameter['guide_id'] = guideId;
            }
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            if (includeAllGuides !== undefined) {
                localVarQueryParameter['includeAllGuides'] = includeAllGuides;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/guides`,
                sdkMethod: 'v2GetGuides',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data. If pack class is clinical, it would have program along with guides. If pack class is not clinical, it would have program only. Response order will match the order of requested pack IDs.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} packId One or more pack classes, sent in the form pack_id&#x3D;calm-health-anxiety&amp;pack_id&#x3D;calm-health-depression&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPacks: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, packId, acceptLanguage, strict, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'recipientId', recipientId);
            // verify required parameter 'packId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'packId', packId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/packs`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (packId) {
                localVarQueryParameter['pack_id'] = packId;
            }
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/packs`,
                sdkMethod: 'v2GetPacks',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a specific playlist and all its items. Only accessible by the owning recipient.
         * @summary Get a playlist with its items
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPlaylist: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, playlistId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylist', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylist', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylist', 'recipientId', recipientId);
            // verify required parameter 'playlistId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylist', 'playlistId', playlistId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{playlist_id}', encodeURIComponent(String(playlistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`,
                sdkMethod: 'v2GetPlaylist',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all playlists for the recipient. Only returns playlists owned by the authenticated user.
         * @summary Get playlists for a recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPlaylists: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylists', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylists', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPlaylists', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists`,
                sdkMethod: 'v2GetPlaylists',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data. Response order will match the order of requested program IDs.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {boolean} [withGuides] Default value is true. If true, guides will be included in the response. If false, guides will not be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, programId, acceptLanguage, strict, withGuides, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'recipientId', recipientId);
            // verify required parameter 'programId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'programId', programId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/programs`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (programId) {
                localVarQueryParameter['program_id'] = programId;
            }
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            if (withGuides !== undefined) {
                localVarQueryParameter['with_guides'] = withGuides;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/programs`,
                sdkMethod: 'v2GetPrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {number} [sampleSize] Number of the recipient\&#39;s most recently listened guides to sample as input for generating recommendations. Defaults to a server-configured value if omitted.
         * @param {number} [resultsSize] Number of recommended guides to return. Defaults to a server-configured value if omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MediaGuideRecommendations: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, sampleSize, resultsSize, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2MediaGuideRecommendations', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2MediaGuideRecommendations', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2MediaGuideRecommendations', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/recommendations/guides`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (sampleSize !== undefined) {
                localVarQueryParameter['sample_size'] = sampleSize;
            }
            if (resultsSize !== undefined) {
                localVarQueryParameter['results_size'] = resultsSize;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/recommendations/guides`,
                sdkMethod: 'v2MediaGuideRecommendations',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get recommendations for the recipient based on an emotion
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} emotion The emotion that the recipient wants recommendations for
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {Array<string>} [factor] The factors relating to the recipient\&#39;s emotion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecommendationsForEmotion: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, emotion, acceptLanguage, factor, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2RecommendationsForEmotion', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2RecommendationsForEmotion', 'recipientId', recipientId);
            // verify required parameter 'emotion' is not null or undefined
            (0, common_1.assertParamExists)('v2RecommendationsForEmotion', 'emotion', emotion);
            const localVarPath = `/v2/media/recipients/{recipient_id}/recommendations/emotions`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (emotion !== undefined) {
                localVarQueryParameter['emotion'] = emotion;
            }
            if (factor) {
                localVarQueryParameter['factor'] = factor;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/recommendations/emotions`,
                sdkMethod: 'v2RecommendationsForEmotion',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the last_accessed_at timestamp for a playlist. Returns 404 if the playlist does not exist or does not belong to the recipient.
         * @summary Record access to a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecordPlaylistAccess: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, playlistId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2RecordPlaylistAccess', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2RecordPlaylistAccess', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2RecordPlaylistAccess', 'recipientId', recipientId);
            // verify required parameter 'playlistId' is not null or undefined
            (0, common_1.assertParamExists)('v2RecordPlaylistAccess', 'playlistId', playlistId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/access`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{playlist_id}', encodeURIComponent(String(playlistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/access`,
                sdkMethod: 'v2RecordPlaylistAccess',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdateGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, guideId, acceptLanguage, mediaUpdateGuide, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'recipientId', recipientId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'guideId', guideId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/guides/{guide_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{guide_id}', encodeURIComponent(String(guideId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/guides/{guide_id}`,
                sdkMethod: 'v2UpdateGuide',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdateGuide, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a playlist\'s name. Returns 404 if the playlist does not exist.
         * @summary Update a recipient\'s playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {MediaUpdatePlaylistRequest} mediaUpdatePlaylistRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdatePlaylist: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, playlistId, mediaUpdatePlaylistRequest, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdatePlaylist', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdatePlaylist', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdatePlaylist', 'recipientId', recipientId);
            // verify required parameter 'playlistId' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdatePlaylist', 'playlistId', playlistId);
            // verify required parameter 'mediaUpdatePlaylistRequest' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdatePlaylist', 'mediaUpdatePlaylistRequest', mediaUpdatePlaylistRequest);
            const localVarPath = `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{playlist_id}', encodeURIComponent(String(playlistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`,
                sdkMethod: 'v2UpdatePlaylist',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdatePlaylistRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MediaV2ApiAxiosParamCreator = MediaV2ApiAxiosParamCreator;
/**
 * MediaV2Api - functional programming interface
 */
const MediaV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MediaV2ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaCopyDataToNewRecipientV2(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mediaCopyDataToNewRecipientV2(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.mediaCopyDataToNewRecipientV2']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:         * reset progress duration for all guides in the pack class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRecipientPackClassPrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchRecipientPackClassPrograms(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.patchRecipientPackClassPrograms']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Add a guide or program to a playlist. Returns 409 if the content is already present in the playlist. Returns 404 if the playlist does not exist or does not belong to the recipient. Returns 422 if the playlist has reached the 256-item limit.
         * @summary Add an item to a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {MediaCreatePlaylistItemRequest} mediaCreatePlaylistItemRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AddPlaylistItem(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2AddPlaylistItem(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2AddPlaylistItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Add a guide to one or more playlists. Playlists where the content already exists are skipped. Returns 404 if any playlist does not exist or does not belong to the recipient. Returns 422 if any playlist has reached the 256-item limit.
         * @summary Add an item to multiple playlists
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaBulkCreatePlaylistItemRequest} mediaBulkCreatePlaylistItemRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BulkAddPlaylistItem(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2BulkAddPlaylistItem(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2BulkAddPlaylistItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a new playlist for the recipient with an initial item. Returns 422 if the recipient already has 64 playlists.
         * @summary Create a playlist for a recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaCreatePlaylistRequest} mediaCreatePlaylistRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CreatePlaylist(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CreatePlaylist(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2CreatePlaylist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Soft delete recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeleteGuides(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2DeleteGuides(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2DeleteGuides']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Soft-delete a playlist and all its items. Only the owning recipient may delete their playlist. Returns 404 if the playlist does not exist or is already deleted.
         * @summary Delete a recipient\'s playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeletePlaylist(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2DeletePlaylist(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2DeletePlaylist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Soft-delete a single item from a playlist. Returns 404 if the item does not exist or does not belong to the recipient\'s playlist.
         * @summary Remove an item from a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {number} itemId Playlist Item ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeletePlaylistItem(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2DeletePlaylistItem(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2DeletePlaylistItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Permanently delete all guides and playlists (including items) for a recipient.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ExpungePrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ExpungePrograms(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2ExpungePrograms']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get recently played clinical guides, favorite clinical guides
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgramGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetClinicalProgramGuide(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetClinicalProgramGuide']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Fetch user\'s progress of clinical media
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [clinicalProgramsOnly] If true, only return progress only for clinical programs
         * @param {Array<string>} [packClasses] If provided, only return progress for the specified clinical pack classes. If not provided, return progress for all known clinical pack classes.  **Note: given packClasses should be clinical pack classes.**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgress(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetClinicalProgress(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetClinicalProgress']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Fetch one or more feeds (collections of packs) from the DTC Content Service. The feeds are cached using the standard Redis caching pattern. Response order will match the order of requested feed IDs.
         * @summary Get feeds by ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} feedId One or more feed IDs, sent in the form feed_id&#x3D;calm-health-home&amp;feed_id&#x3D;calm-health-anxiety&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetFeeds(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetFeeds(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetFeeds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data. Note: This endpoint returns programs with guides. Response order will match the order of requested guide IDs (by first occurrence of each guide\'s program).
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;... Response order will match the order of requested IDs (by first occurrence of each guide\&#39;s program).
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {boolean} [includeAllGuides] Default value is false. If true, returns all guides in the response, even if the recipient has no progress with the guide.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetGuides(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetGuides(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetGuides']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data. If pack class is clinical, it would have program along with guides. If pack class is not clinical, it would have program only. Response order will match the order of requested pack IDs.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} packId One or more pack classes, sent in the form pack_id&#x3D;calm-health-anxiety&amp;pack_id&#x3D;calm-health-depression&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPacks(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPacks(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetPacks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a specific playlist and all its items. Only accessible by the owning recipient.
         * @summary Get a playlist with its items
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPlaylist(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPlaylist(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetPlaylist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all playlists for the recipient. Only returns playlists owned by the authenticated user.
         * @summary Get playlists for a recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPlaylists(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPlaylists(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetPlaylists']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data. Response order will match the order of requested program IDs.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {boolean} [withGuides] Default value is true. If true, guides will be included in the response. If false, guides will not be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPrograms(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2GetPrograms']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {number} [sampleSize] Number of the recipient\&#39;s most recently listened guides to sample as input for generating recommendations. Defaults to a server-configured value if omitted.
         * @param {number} [resultsSize] Number of recommended guides to return. Defaults to a server-configured value if omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MediaGuideRecommendations(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MediaGuideRecommendations(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2MediaGuideRecommendations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get recommendations for the recipient based on an emotion
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} emotion The emotion that the recipient wants recommendations for
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {Array<string>} [factor] The factors relating to the recipient\&#39;s emotion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecommendationsForEmotion(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2RecommendationsForEmotion(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2RecommendationsForEmotion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Updates the last_accessed_at timestamp for a playlist. Returns 404 if the playlist does not exist or does not belong to the recipient.
         * @summary Record access to a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecordPlaylistAccess(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2RecordPlaylistAccess(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2RecordPlaylistAccess']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdateGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2UpdateGuide(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2UpdateGuide']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a playlist\'s name. Returns 404 if the playlist does not exist.
         * @summary Update a recipient\'s playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {MediaUpdatePlaylistRequest} mediaUpdatePlaylistRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdatePlaylist(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2UpdatePlaylist(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MediaV2Api.v2UpdatePlaylist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.MediaV2ApiFp = MediaV2ApiFp;
/**
 * MediaV2Api - factory interface
 */
const MediaV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MediaV2ApiFp)(configuration);
    return {
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaCopyDataToNewRecipientV2(params, options) {
            return localVarFp
                .mediaCopyDataToNewRecipientV2(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:         * reset progress duration for all guides in the pack class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRecipientPackClassPrograms(params, options) {
            return localVarFp
                .patchRecipientPackClassPrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Add a guide or program to a playlist. Returns 409 if the content is already present in the playlist. Returns 404 if the playlist does not exist or does not belong to the recipient. Returns 422 if the playlist has reached the 256-item limit.
         * @summary Add an item to a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {MediaCreatePlaylistItemRequest} mediaCreatePlaylistItemRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AddPlaylistItem(params, options) {
            return localVarFp
                .v2AddPlaylistItem(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Add a guide to one or more playlists. Playlists where the content already exists are skipped. Returns 404 if any playlist does not exist or does not belong to the recipient. Returns 422 if any playlist has reached the 256-item limit.
         * @summary Add an item to multiple playlists
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaBulkCreatePlaylistItemRequest} mediaBulkCreatePlaylistItemRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BulkAddPlaylistItem(params, options) {
            return localVarFp
                .v2BulkAddPlaylistItem(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new playlist for the recipient with an initial item. Returns 422 if the recipient already has 64 playlists.
         * @summary Create a playlist for a recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaCreatePlaylistRequest} mediaCreatePlaylistRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CreatePlaylist(params, options) {
            return localVarFp
                .v2CreatePlaylist(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft delete recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeleteGuides(params, options) {
            return localVarFp
                .v2DeleteGuides(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a playlist and all its items. Only the owning recipient may delete their playlist. Returns 404 if the playlist does not exist or is already deleted.
         * @summary Delete a recipient\'s playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeletePlaylist(params, options) {
            return localVarFp
                .v2DeletePlaylist(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a single item from a playlist. Returns 404 if the item does not exist or does not belong to the recipient\'s playlist.
         * @summary Remove an item from a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {number} itemId Playlist Item ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeletePlaylistItem(params, options) {
            return localVarFp
                .v2DeletePlaylistItem(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Permanently delete all guides and playlists (including items) for a recipient.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ExpungePrograms(params, options) {
            return localVarFp
                .v2ExpungePrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get recently played clinical guides, favorite clinical guides
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgramGuide(params, options) {
            return localVarFp
                .v2GetClinicalProgramGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch user\'s progress of clinical media
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [clinicalProgramsOnly] If true, only return progress only for clinical programs
         * @param {Array<string>} [packClasses] If provided, only return progress for the specified clinical pack classes. If not provided, return progress for all known clinical pack classes.  **Note: given packClasses should be clinical pack classes.**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgress(params, options) {
            return localVarFp
                .v2GetClinicalProgress(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch one or more feeds (collections of packs) from the DTC Content Service. The feeds are cached using the standard Redis caching pattern. Response order will match the order of requested feed IDs.
         * @summary Get feeds by ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} feedId One or more feed IDs, sent in the form feed_id&#x3D;calm-health-home&amp;feed_id&#x3D;calm-health-anxiety&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetFeeds(params, options) {
            return localVarFp
                .v2GetFeeds(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data. Note: This endpoint returns programs with guides. Response order will match the order of requested guide IDs (by first occurrence of each guide\'s program).
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;... Response order will match the order of requested IDs (by first occurrence of each guide\&#39;s program).
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {boolean} [includeAllGuides] Default value is false. If true, returns all guides in the response, even if the recipient has no progress with the guide.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetGuides(params, options) {
            return localVarFp
                .v2GetGuides(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data. If pack class is clinical, it would have program along with guides. If pack class is not clinical, it would have program only. Response order will match the order of requested pack IDs.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} packId One or more pack classes, sent in the form pack_id&#x3D;calm-health-anxiety&amp;pack_id&#x3D;calm-health-depression&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPacks(params, options) {
            return localVarFp
                .v2GetPacks(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a specific playlist and all its items. Only accessible by the owning recipient.
         * @summary Get a playlist with its items
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPlaylist(params, options) {
            return localVarFp
                .v2GetPlaylist(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all playlists for the recipient. Only returns playlists owned by the authenticated user.
         * @summary Get playlists for a recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPlaylists(params, options) {
            return localVarFp
                .v2GetPlaylists(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data. Response order will match the order of requested program IDs.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;... Response order will match the order of requested IDs.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
         * @param {boolean} [withGuides] Default value is true. If true, guides will be included in the response. If false, guides will not be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPrograms(params, options) {
            return localVarFp
                .v2GetPrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {number} [sampleSize] Number of the recipient\&#39;s most recently listened guides to sample as input for generating recommendations. Defaults to a server-configured value if omitted.
         * @param {number} [resultsSize] Number of recommended guides to return. Defaults to a server-configured value if omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MediaGuideRecommendations(params, options) {
            return localVarFp
                .v2MediaGuideRecommendations(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get recommendations for the recipient based on an emotion
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} emotion The emotion that the recipient wants recommendations for
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {Array<string>} [factor] The factors relating to the recipient\&#39;s emotion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecommendationsForEmotion(params, options) {
            return localVarFp
                .v2RecommendationsForEmotion(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates the last_accessed_at timestamp for a playlist. Returns 404 if the playlist does not exist or does not belong to the recipient.
         * @summary Record access to a playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2RecordPlaylistAccess(params, options) {
            return localVarFp
                .v2RecordPlaylistAccess(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdateGuide(params, options) {
            return localVarFp
                .v2UpdateGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update a playlist\'s name. Returns 404 if the playlist does not exist.
         * @summary Update a recipient\'s playlist
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} playlistId Playlist ID
         * @param {MediaUpdatePlaylistRequest} mediaUpdatePlaylistRequest
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdatePlaylist(params, options) {
            return localVarFp
                .v2UpdatePlaylist(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.MediaV2ApiFactory = MediaV2ApiFactory;
/**
 * MediaV2Api - object-oriented interface
 */
class MediaV2Api extends base_1.BaseAPI {
    /**
     * URL `/v2/media/recipients/{recipient_id}/copy`
     * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mediaCopyDataToNewRecipientV2(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .mediaCopyDataToNewRecipientV2(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/packs/{class}/programs`
     * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:         * reset progress duration for all guides in the pack class
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchRecipientPackClassPrograms(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .patchRecipientPackClassPrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/items`
     * Add a guide or program to a playlist. Returns 409 if the content is already present in the playlist. Returns 404 if the playlist does not exist or does not belong to the recipient. Returns 422 if the playlist has reached the 256-item limit.
     * @summary Add an item to a playlist
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} playlistId Playlist ID
     * @param {MediaCreatePlaylistItemRequest} mediaCreatePlaylistItemRequest
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2AddPlaylistItem(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2AddPlaylistItem(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/items`
     * Add a guide to one or more playlists. Playlists where the content already exists are skipped. Returns 404 if any playlist does not exist or does not belong to the recipient. Returns 422 if any playlist has reached the 256-item limit.
     * @summary Add an item to multiple playlists
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {MediaBulkCreatePlaylistItemRequest} mediaBulkCreatePlaylistItemRequest
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2BulkAddPlaylistItem(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2BulkAddPlaylistItem(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists`
     * Create a new playlist for the recipient with an initial item. Returns 422 if the recipient already has 64 playlists.
     * @summary Create a playlist for a recipient
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {MediaCreatePlaylistRequest} mediaCreatePlaylistRequest
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2CreatePlaylist(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2CreatePlaylist(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}`
     * Soft delete recipient\'s guides progress
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DeleteGuides(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2DeleteGuides(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`
     * Soft-delete a playlist and all its items. Only the owning recipient may delete their playlist. Returns 404 if the playlist does not exist or is already deleted.
     * @summary Delete a recipient\'s playlist
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} playlistId Playlist ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DeletePlaylist(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2DeletePlaylist(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/items/{item_id}`
     * Soft-delete a single item from a playlist. Returns 404 if the item does not exist or does not belong to the recipient\'s playlist.
     * @summary Remove an item from a playlist
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} playlistId Playlist ID
     * @param {number} itemId Playlist Item ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DeletePlaylistItem(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2DeletePlaylistItem(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/expunge`
     * Permanently delete all guides and playlists (including items) for a recipient.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2ExpungePrograms(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2ExpungePrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}`
     * Get recently played clinical guides, favorite clinical guides
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetClinicalProgramGuide(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetClinicalProgramGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/progress`
     * Fetch user\'s progress of clinical media
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [clinicalProgramsOnly] If true, only return progress only for clinical programs
     * @param {Array<string>} [packClasses] If provided, only return progress for the specified clinical pack classes. If not provided, return progress for all known clinical pack classes.  **Note: given packClasses should be clinical pack classes.**
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetClinicalProgress(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetClinicalProgress(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/feeds`
     * Fetch one or more feeds (collections of packs) from the DTC Content Service. The feeds are cached using the standard Redis caching pattern. Response order will match the order of requested feed IDs.
     * @summary Get feeds by ID
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} feedId One or more feed IDs, sent in the form feed_id&#x3D;calm-health-home&amp;feed_id&#x3D;calm-health-anxiety&amp;... Response order will match the order of requested IDs.
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetFeeds(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetFeeds(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/guides`
     * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data. Note: This endpoint returns programs with guides. Response order will match the order of requested guide IDs (by first occurrence of each guide\'s program).
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;... Response order will match the order of requested IDs (by first occurrence of each guide\&#39;s program).
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
     * @param {boolean} [includeAllGuides] Default value is false. If true, returns all guides in the response, even if the recipient has no progress with the guide.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetGuides(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetGuides(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/packs`
     * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data. If pack class is clinical, it would have program along with guides. If pack class is not clinical, it would have program only. Response order will match the order of requested pack IDs.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} packId One or more pack classes, sent in the form pack_id&#x3D;calm-health-anxiety&amp;pack_id&#x3D;calm-health-depression&amp;... Response order will match the order of requested IDs.
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetPacks(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetPacks(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`
     * Get a specific playlist and all its items. Only accessible by the owning recipient.
     * @summary Get a playlist with its items
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} playlistId Playlist ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetPlaylist(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetPlaylist(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists`
     * Get all playlists for the recipient. Only returns playlists owned by the authenticated user.
     * @summary Get playlists for a recipient
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetPlaylists(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetPlaylists(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/programs`
     * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data. Response order will match the order of requested program IDs.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;... Response order will match the order of requested IDs.
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [strict] Default value is false. If false, error response will be ignored if any of the provided IDs are invalid OR underlying service returns an error. If true, error response will be returned for any invalid IDs or service errors. Whole response will be returned as an error.
     * @param {boolean} [withGuides] Default value is true. If true, guides will be included in the response. If false, guides will not be included in the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetPrograms(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetPrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/recommendations/guides`
     * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {number} [sampleSize] Number of the recipient\&#39;s most recently listened guides to sample as input for generating recommendations. Defaults to a server-configured value if omitted.
     * @param {number} [resultsSize] Number of recommended guides to return. Defaults to a server-configured value if omitted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2MediaGuideRecommendations(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2MediaGuideRecommendations(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/recommendations/emotions`
     * Get recommendations for the recipient based on an emotion
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} emotion The emotion that the recipient wants recommendations for
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {Array<string>} [factor] The factors relating to the recipient\&#39;s emotion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2RecommendationsForEmotion(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2RecommendationsForEmotion(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}/access`
     * Updates the last_accessed_at timestamp for a playlist. Returns 404 if the playlist does not exist or does not belong to the recipient.
     * @summary Record access to a playlist
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} playlistId Playlist ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2RecordPlaylistAccess(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2RecordPlaylistAccess(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/guides/{guide_id}`
     * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} guideId Guide ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaUpdateGuide} [mediaUpdateGuide]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2UpdateGuide(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2UpdateGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/playlists/{playlist_id}`
     * Update a playlist\'s name. Returns 404 if the playlist does not exist.
     * @summary Update a recipient\'s playlist
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} playlistId Playlist ID
     * @param {MediaUpdatePlaylistRequest} mediaUpdatePlaylistRequest
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2UpdatePlaylist(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2UpdatePlaylist(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.MediaV2Api = MediaV2Api;
//# sourceMappingURL=media-v2-api.js.map